import axios from 'axios';

// Instância da API genérica de VOIP (Mexx.Messenger.Voip).
// Host ÚNICO por ambiente (via env) — é uma API compartilhada multi-tenant; o backend resolve o
// tenant pelo workspace (header Origin, enviado automaticamente pelo browser). Mesmo padrão do Hub.
// Autentica com o token do 2DO (a API valida o token 2DO).
const rawUrl = (process.env.REACT_APP_MEXX_MESSENGER_VOIP_URL || '').replace(/\/+$/, '');
const baseURL = rawUrl ? `${rawUrl}/api` : '/api';

const ApiVoip = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

// Anexa o token atual a cada request (refresh-safe).
ApiVoip.interceptors.request.use((config) => {
  const token = localStorage.getItem('accesstoken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default ApiVoip;
